import React, { Suspense, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// import Plot from 'react-plotly.js';

import { getEventRecordData } from "../../api/kquake";

const Plot = React.lazy(() => import("react-plotly.js"));

const PLOT_COMPONENTS_AND_YAXISES = [
  ["E", "y"],
  ["N", "y2"],
  ["Z", "y3"],
];

export const EventRecordDetailsModal = ({
  record,
  onClose,
  dataCache,
  setDataCache,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    const dataTypesToFetch = [];
    if (record.id in dataCache) {
      if (!("preprocessed" in dataCache[record.id])) {
        dataTypesToFetch.push("preprocessed");
      }
      if (
        !("processed" in dataCache[record.id]) ||
        !("acc" in dataCache[record.id].processed)
      ) {
        dataTypesToFetch.push("processed.acc");
      }
    } else {
      dataTypesToFetch.push("preprocessed");
      dataTypesToFetch.push("processed.acc");
    }

    if (dataTypesToFetch.length > 0) {
      const fetchData = async (recordId) => {
        const data = await getEventRecordData(recordId, dataTypesToFetch);
        setDataCache({
          ...dataCache,
          [record.id]: { ...dataCache[record.id], ...data },
        });
      };
      fetchData(record.id);
    }
  }, [record, dataCache, setDataCache]);

  const [data, setData] = useState([]);
  useEffect(() => {
    if (record.id in dataCache) {
      const { preprocessed, processed } = dataCache[record.id];
      const _data = [];
      if (preprocessed) {
        PLOT_COMPONENTS_AND_YAXISES.forEach(([component, yaxis]) => {
          _data.push({
            type: "scatter",
            mode: "lines",
            name: "unprocessed",
            legendgroup: "unprocessed",
            x0: parseInt(preprocessed[component].startTime * 1000),
            dx: 10,
            y: preprocessed[component].values,
            xaxis: "x",
            yaxis,
            line: {
              color: "red",
              width: 1,
            },
            showlegend: yaxis === "y",
          });
        });
      }
      if (processed) {
        PLOT_COMPONENTS_AND_YAXISES.forEach(([component, yaxis]) => {
          _data.push({
            type: "scatter",
            mode: "lines",
            name: "processed",
            legendgroup: "processed",
            x0: parseInt(processed.acc[component].startTime * 1000),
            dx: 10,
            y: processed.acc[component].values,
            xaxis: "x",
            yaxis,
            line: {
              color: "black",
              width: 1,
            },
            showlegend: yaxis === "y",
          });
        });
      }
      setData(_data);
    } else {
      setData([]);
    }
  }, [record, dataCache]);

  const layout = {
    title: {
      text: `${
        record.eventOriginTimeStrKST
      } (KST), M<sub>L</sub> ${record.evnetMagnitudeML.toFixed(1)}, ${
        record.stationCode
      }, R = ${record.epicentralDistance.toFixed(0)} km`,
    },
    grid: {
      rows: 3,
      columns: 1,
      subplots: ["xy", "xy2", "xy3"],
    },
    xaxis: {
      type: "date",
    },
    yaxis: {
      title: "E (cm/s<sup>2</sup>)",
    },
    yaxis2: {
      title: "N (cm/s<sup>2</sup>)",
    },
    yaxis3: {
      title: "Z (cm/s<sup>2</sup>)",
    },
    // legend: {"orientation": "h"},
  };

  return (
    <div
      style={{
        position: "fixed",
        zIndex: 10681,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div id="modal1" className="modal open" style={{ height: "90%" }}>
        <div className="modal-content" style={{ height: "100%" }}>
          <div className="modal-title">
            {t("page.kesmdb.waveformPreview")} - {record.streamId}
          </div>
          <br />
          <div className="clearfix">
            <br />
          </div>
          <Suspense fallback={<div>Loading...</div>}>
            <Plot
              data={data}
              layout={layout}
              config={{ responsive: true }}
              useResizeHandler={true}
              style={{ width: "90%", height: "90%" }}
            />
          </Suspense>
        </div>
        <a
          className="modal-close waves-effect waves-green btn-flat"
          onClick={onClose}
        >
          <i className="ion ion-md-close"></i>
        </a>
      </div>
    </div>
  );
};
